<div class="card card-plain">
	<div class="card-header" role="tab" id="headingVendorChat">
		<a href="javascript:void(0)" (click)="toggle()" [attr.aria-expanded]="expanded" aria-controls="collapseVendorChat">
			<h5>
				Vendor Chat ({{ messages.length }})
				<span *ngIf="unreadCount > 0" class="vendor-chat-badge">{{ unreadCount }} new</span>
				<i class="nc-icon nc-minimal-down"> </i>
			</h5>
		</a>
	</div>
	<div id="collapseVendorChat" role="tabpanel" aria-labelledby="headingVendorChat" *ngIf="expanded">
		<div class="card-body">
			<div class="vendor-chat-messages">
				<div *ngIf="loading" class="vendor-chat-empty">Loading messages…</div>
				<div *ngIf="!loading && messages.length === 0" class="vendor-chat-empty">
					No messages yet. Messages sent here are visible to the vendor.
				</div>
				<div
					*ngFor="let message of messages; trackBy: trackById"
					class="vendor-chat-row"
					[class.own]="message.senderSide === 'Staff'"
					[class.has-reactions]="message.vendorReaction || message.staffReaction"
				>
					<div class="vendor-chat-bubble" [class.own]="message.senderSide === 'Staff'">
						<div class="vendor-chat-sender">
							{{ message.senderDisplayName || (message.senderSide === 'Vendor' ? 'Vendor' : 'Staff') }}
						</div>
						<div class="vendor-chat-text">{{ message.text }}</div>
						<div class="vendor-chat-time">
							{{ toUtcDate(message.createdDate) | date : 'MMM d, y h:mm a' }}
							<span *ngIf="message.senderSide === 'Staff' && message.isReadByVendor">· Read by vendor</span>
						</div>
						<div class="rx-chips" *ngIf="message.vendorReaction || message.staffReaction">
							<span *ngIf="message.vendorReaction" title="Vendor's reaction">{{ message.vendorReaction }}</span>
							<span *ngIf="message.staffReaction" title="Staff reaction">{{ message.staffReaction }}</span>
						</div>
					</div>
					<div class="rx-anchor">
						<button type="button" class="rx-add" title="React" (click)="toggleReactionPicker(message.id)">
							<i class="fa fa-smile-o"></i>
						</button>
						<div class="rx-picker" *ngIf="reactionPickerFor === message.id">
							<button
								type="button"
								*ngFor="let reaction of reactionOptions"
								[class.active]="message.staffReaction === reaction"
								(click)="react(message, reaction)"
							>
								{{ reaction }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="vendor-chat-error" *ngIf="composerError">
				<i class="fa fa-exclamation-circle"></i> {{ composerError }}
			</div>
			<div class="vendor-chat-composer">
				<textarea
					[(ngModel)]="newMessageText"
					(ngModelChange)="onComposerInput()"
					rows="2"
					(keydown.enter)="$event.preventDefault(); sendMessage()"
				></textarea>
				<button
					type="button"
					class="btn btn-info"
					(click)="sendMessage()"
					[disabled]="sending || !newMessageText.trim()"
				>
					{{ sending ? 'Sending…' : 'Send' }}
				</button>
			</div>
		</div>
	</div>
</div>
